var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"exemption-order-view"},[_c('ExemptionOrderComponent',{attrs:{"exemptionOrder":_vm.exemptionOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }